import {Spin} from "antd";
import FlexStyled from '@/styled/FlexStyled';

export default () => {
    return <FlexStyled $justifyContent='center' style={{paddingTop: 60}}>
        <Spin/>
    </FlexStyled>
}
